import { render, staticRenderFns } from "./MersisNumarasi.vue?vue&type=template&id=45a5c2d1&scoped=true"
import script from "./MersisNumarasi.vue?vue&type=script&lang=ts"
export * from "./MersisNumarasi.vue?vue&type=script&lang=ts"
import style0 from "./MersisNumarasi.vue?vue&type=style&index=0&id=45a5c2d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a5c2d1",
  null
  
)

export default component.exports